export interface SharedEntry {
  id: number
  track_id: number
  title: string
  artist: string
  duration_ms: number
  availability: 'playable' | 'preparing' | 'unavailable'
  reason: string
  cover_url: string | null
}
export interface SharedCollection {
  id: string
  kind: 'song' | 'playlist'
  title: string
  description: string
  expires_at: string | null
  entries: SharedEntry[]
  counts: Record<'playable' | 'preparing' | 'unavailable', number>
}
export interface OwnerShare extends SharedCollection {
  url: string
  revoked: boolean
}
export function safeShareReturn(value: unknown): string {
  return typeof value === 'string' && /^\/share\/[0-9a-f-]{36}$/.test(value) ? value : '/'
}
export function nextPlayable(
  entries: SharedEntry[],
  index: number,
  direction = 1,
  failed = new Set<number>(),
): number {
  for (let i = index + direction; i >= 0 && i < entries.length; i += direction) {
    if (entries[i].availability === 'playable' && !failed.has(entries[i].id)) return i
  }
  return -1
}
